// WebsiteShow.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AddIcon from "@mui/icons-material/Add";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

export const WebsiteShow = () => {
  const [websites, setWebsites] = useState([]);
  const [deleteWebsiteId, setDeleteWebsiteId] = useState(null);
  const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const navigator = useNavigate();
  const navigate = useNavigate();
  useEffect(() => {
    async function getInfo() {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/verify`,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (data.message === "Please login first") {
          navigate("/adminLogin");
        }
      } catch (error) {
        console.log(error);
      }
    }
    getInfo();
  }, []);
  const getAllWebsites = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/blogs/hero/`,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      setWebsites(data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteWebsite = async () => {
    const websiteId = deleteWebsiteId;
    try {
      // Perform the delete operation using the websiteId
      const data = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/blogs/hero/delete/${websiteId}`,

        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      handleCloseDeleteDialog();
      // Refresh the website list
      getAllWebsites();
    } catch (error) {
      console.log(error);
    }
  };

  const handleOpenDeleteDialog = (websiteId) => {
    setDeleteWebsiteId(websiteId);
    setDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setDeleteWebsiteId(null);
  };
  const handleCreateNewHero = () => {
    navigator("/website/create");
  };

  useEffect(() => {
    getAllWebsites();
  }, []);

  return (
    <div>
      <div className="banner">
        <div
          style={{ fontSize: "2rem", fontWeight: "500", marginBottom: "1rem" }}
        >
          Hero Data:
        </div>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={handleCreateNewHero}
          style={{ marginBottom: "1.5rem" }}
        >
          Create New Hero
        </Button>
      </div>

      <TableContainer component={Paper}>
        <Table>
          <TableHead style={{ backgroundColor: "gainsboro" }}>
            <TableRow>
              <TableCell>Page</TableCell>
              <TableCell>Key</TableCell>
              <TableCell>Value</TableCell>
              <TableCell>Action</TableCell>
              {/* Add more columns based on your website data */}
            </TableRow>
          </TableHead>
          <TableBody>
            {websites.map((website) => (
              <TableRow key={website._id}>
                <TableCell>{website.page}</TableCell>
                <TableCell>{website.key}</TableCell>
                <TableCell>{website.value}</TableCell>
                <TableCell>
                  <Button
                    component={Link}
                    to={`/website/${website._id}`}
                    variant="contained"
                    color="primary"
                  >
                    <VisibilityIcon />
                  </Button>
                  <Button
                    component={Link}
                    to={`/website/${website._id}/edit`}
                    variant="contained"
                    color="warning"
                  >
                    <EditIcon />
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => handleOpenDeleteDialog(website._id)}
                  >
                    <DeleteIcon />
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog open={isDeleteDialogOpen} onClose={handleCloseDeleteDialog}>
        <DialogTitle>Delete Confirmation</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this website?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteWebsite} color="primary" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
